<div class="container-fluid">
  <div class="mct-flex mct-row mb-3">
    <h3>
      {{ 'events.settings.promo-codes.title' | translate | titlecase }}
      <a
        href="https://support.weblinkinternational.com/hc/en-us/articles/235639008-Event-Settings-Promo-Codes"
        target="_blank"
        class="ml-2"
      >
        <i class="pi pi-question-circle wc-help-icon" [title]="'events.settings.promo-codes.promo-codes-title-help' | translate"></i>
      </a>
    </h3>
  </div>

  <div class="mct-flex mct-row mct-justify-between mct-items-center mb-10">
    <button
      app-add-button
      [disabled]="userAccessLevel < 2"
      [label]="'events.settings.promo-codes.add-button-label' | translate | titlecase"
      (click)="newEventPromoCodes()"
    ></button>

    <button
      pButton
      type="button"
      (click)="exportAllPromoCodes()"
      class="atlas-btn atlas-btn-secondary tall"
      icon="pi pi-download"
      [label]="'events.settings.promo-codes.export-usage-button-label' | translate | titlecase"
    ></button>
  </div>

  <div [hidden]="!loadingPromoCodes" class="my-3 text-center">
    <wl-busy [show]="loadingPromoCodes"></wl-busy>
    <p class="mt-2 text-muted">{{ 'common.loading' | translate }}...</p>
  </div>

  <div [hidden]="!loadPromoCodesError" class="alert alert-danger">
    <i class="pi pi-exclamation-circle mr-2"></i>
    <strong>{{ 'common.error' | translate | titlecase }}:</strong> {{ loadPromoCodesError }}
  </div>

  <p-table
    [showGridlines]="true"
    #promoCodesDataGrid
    [rows]="100"
    [value]="eventPromoCodes"
    [hidden]="loadingPromoCodes"
    class="p-datatable-striped shadow-sm mb-10"
    responsiveLayout="scroll"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Name">
          {{ 'events.settings.promo-codes.promo-name-column-header' | translate | titlecase }} <p-sortIcon field="Name"></p-sortIcon>
        </th>
        <th pSortableColumn="Code">
          {{ 'events.settings.promo-codes.code-column-header' | translate | titlecase }} <p-sortIcon field="Code"></p-sortIcon>
        </th>
        <th class="text-right">{{ 'events.settings.promo-codes.discount-column-header' | translate | titlecase }}</th>
        <th class="text-center">{{ 'events.settings.promo-codes.used-column-header' | translate | titlecase }}</th>
        <th class="text-center">{{ 'events.settings.promo-codes.max-uses-column-header' | translate | titlecase }}</th>
        <th class="text-right">{{ 'events.settings.promo-codes.total-discounts-column-header' | translate | titlecase }}</th>
        <th style="width: 150px"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-dataItem>
      <tr>
        <td>
          <span class="font-weight-bold">{{ dataItem.Name }}</span>
        </td>
        <td>
          <code class="promo-code-badge">{{ dataItem.Code }}</code>
        </td>
        <td class="text-right">
          <span class="p-2" [ngClass]="dataItem.DiscountType == 1 ? 'badge-percent' : 'badge-dollar'">
            {{ dataItem.DiscountType == 0 ? (dataItem.Discount | currency) : dataItem.Discount + '%' }}
          </span>
        </td>
        <td class="text-center">{{ dataItem.Used }}</td>
        <td class="text-center">
          <span *ngIf="dataItem.MaxUses > 0">{{ dataItem.MaxUses }}</span>
          <span *ngIf="!dataItem.MaxUses || dataItem.MaxUses <= 0" class="text-muted small">
            {{ 'events.settings.promo-codes.no-max-uses' | translate | titlecase }}
          </span>
        </td>
        <td class="text-right font-weight-bold">
          {{ -dataItem.TotalDiscounts | currency }}
        </td>
        <td class="text-right">
          <div class="mct-flex mct-row mct-gap-5">
            <button
              pButton
              type="button"
              class="p-button-text p-button-sm"
              icon="pi pi-pencil"
              (click)="editPromoCode(dataItem.PromoCodeId)"
              [disabled]="userAccessLevel < 2"
            ></button>
            <button
              pButton
              type="button"
              class="atlas-btn atlas-btn-danger p-button-text p-button-sm"
              icon="pi pi-trash"
              (click)="confirmDeletePromoCode(dataItem.PromoCodeId)"
              [disabled]="dataItem.Used > 0 || userAccessLevel < 2"
            ></button>
            <button
              pButton
              type="button"
              class="atlas-btn atlas-btn-secondary p-button-text p-button-sm"
              icon="pi pi-download"
              (click)="exportPromoCode(dataItem.PromoCodeId)"
              [title]="'common.export' | translate"
            ></button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <app-back-to-top></app-back-to-top>
</div>

<p-dialog
  #eventPromoCodeModal
  modal="true"
  [(visible)]="showEditModal"
  [closable]="true"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title">
      <i class="pi pi-ticket mr-2"></i>
      {{ 'events.settings.promo-codes.title' | translate | titlecase }}
    </h4>
  </ng-template>

  <div class="container-fluid pt-2">
    <div [hidden]="!loadPromoCodeState.busy" class="text-center py-5">
      <wl-busy [show]="loadPromoCodeState.busy"></wl-busy>
    </div>

    <div class="alert alert-danger" *ngIf="loadPromoCodeState.message && !loadPromoCodeState.success">
      {{ loadPromoCodeState.message }}
    </div>

    <form #promoCodeForm="ngForm" class="form-horizontal" [hidden]="loadPromoCodeState.busy || !loadPromoCodeState.success">
      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.promo-codes.name-label' | translate | titlecase }}*</label>
        <div class="col-sm-9">
          <input
            class="form-control"
            type="text"
            name="promoCodeName"
            [(ngModel)]="selectedEventPromoCode.Name"
            required
            placeholder="e.g. Early Bird Special"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.promo-codes.code-label' | translate | titlecase }}*</label>
        <div class="col-sm-9">
          <input
            class="form-control text-uppercase font-weight-bold"
            type="text"
            name="promoCodeCode"
            [(ngModel)]="selectedEventPromoCode.Code"
            required
            placeholder="SAVE20"
          />
          <small class="text-muted"
            ><i class="pi pi-info-circle mr-1"></i> {{ 'events.settings.promo-codes.code-warning-label' | translate }}</small
          >
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.promo-codes.adjustment-type-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <wl-adjustment-type-selector
            [includeNoneValue]="false"
            name="promoCodeAdjustmentType"
            [(ngModel)]="selectedEventPromoCode.AdjustmentTypeId"
          ></wl-adjustment-type-selector>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.promo-codes.discount-amount-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <div class="input-group">
            <span class="input-group-addon p-0 overflow-hidden" style="min-width: 100px">
              <p-selectButton
                [options]="[
                  { label: '$', value: 0 },
                  { label: '%', value: 1 },
                ]"
                name="discountType"
                [(ngModel)]="selectedEventPromoCode.DiscountType"
                styleClass="discount-toggle"
              ></p-selectButton>
            </span>
            <input class="form-control" type="number" name="promoCodeDiscountAmount" [(ngModel)]="selectedEventPromoCode.Discount" />
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="col-sm-9 col-sm-offset-3">
          <p-checkbox binary="true" name="applyOncePerReg" [(ngModel)]="selectedEventPromoCode.ApplyOncePerReg"> </p-checkbox>
          <label class="control-label"
            >{{ 'events.settings.promo-codes.apply-once-per-registration-label' | translate | titlecase }}*</label
          >
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.promo-codes.applies-to-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <div class="p-3 bg-light">
            <div [hidden]="!loadingEventItems" class="text-center">
              <i class="pi pi-spin pi-spinner mr-2"></i> {{ 'common.loading' | translate }}
            </div>
            <div *ngFor="let eventItem of eventItems; let promoCodeNdx = index" class="mb-2">
              <p-checkbox binary="true" [name]="'promoCodeEventItemApply' + promoCodeNdx" [(ngModel)]="eventItem.apply"> </p-checkbox>
              <label class="control-label">{{ eventItem.eventItemName }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.promo-codes.usage-limit-label' | translate | titlecase }}</label>
        <div class="col-sm-4">
          <input
            class="form-control"
            type="number"
            name="promoCodeMaxUses"
            [(ngModel)]="selectedEventPromoCode.MaxUses"
            placeholder="Unlimited"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.promo-codes.start-date-label' | translate | titlecase }}</label>
        <div class="col-sm-4">
          <wl-date-selector name="promoCodeStartDate" [(ngModel)]="selectedEventPromoCode.StartDate"></wl-date-selector>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label text-right">{{ 'events.settings.promo-codes.end-date-label' | translate | titlecase }}</label>
        <div class="col-sm-4">
          <wl-date-selector name="promoCodeEndDate" [(ngModel)]="selectedEventPromoCode.EndDate"></wl-date-selector>
        </div>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger text-left" *ngIf="saveError">
      {{ saveError }}
    </div>
    <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-10">
      <wl-busy [show]="saving"></wl-busy>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        (click)="savePromoCode()"
        [disabled]="!promoCodeForm.valid || saving"
        icon="pi pi-save"
        [label]="(saving ? 'common.saving' : 'common.save') | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary"
        (click)="showEditModal = false"
        [disabled]="saving"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  #confirmDeletePromoCodeModal
  modal="true"
  [(visible)]="showDeleteModal"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
>
  <div class="text-center p-4">
    <i class="pi pi-exclamation-triangle text-danger" style="font-size: 3rem"></i>
    <h5 class="mt-3">{{ 'events.settings.promo-codes.delete-confirm' | translate }}</h5>
  </div>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger text-left" *ngIf="deleteError">
      {{ deleteError }}
    </div>
    <div class="mct-flex mct-row mct-gap-10">
      <wl-busy [show]="deleting"></wl-busy>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-danger"
        (click)="deletePromoCode()"
        [disabled]="deleting"
        icon="pi pi-trash"
        [label]="(deleting ? 'common.deleting' : 'common.delete') | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary"
        (click)="showDeleteModal = false"
        [disabled]="deleting"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>
